import classNames from 'classnames';
import React from 'react';
import { CustomElementProps } from '../../types/react-props-types';
import './ContentHeader.scss';

interface ContentHeaderProps extends CustomElementProps {
  onClick?: (e: any) => void;
  'data-testid'?: string;
}

const ContentHeader = (props: ContentHeaderProps): React.JSX.Element => {
  const { id, className, children, onClick, 'data-testid': dataTestId } = props;
  return (
    <div
      id={id}
      className={classNames('content-header', className)}
      role='content-header'
      onClick={(e: any) => onClick?.(e)}
      data-testid={dataTestId}
    >
      {children}
    </div>
  );
};

export default ContentHeader;
